import { Customer_Requirements } from "data/endpoints";
import IAppState from "infrastructure/store/IAppState";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import RequirementSimplified from "../components/RequirementSimplified";
import RequirementSimplifiedHeader from "../components/RequirementSimplifiedHeader";
import { DataGridId } from "features/shared/components/dataGrid/DataGridId";
import IExternalFilterData from "features/shared/components/dataFilter/IExternalFilterData";
import RequirementTypesDialog from "../components/requirementTypesDialog/RequirementTypesDialog";
import DataGrid from "features/shared/components/dataGrid/DataGrid";
import RolesChecker from "features/customer/components/RolesChecker";
import {
  loadDataFilterConfig,
  loadPortalConfig,
} from "features/shared/helpers/modules";
import { useTranslation } from "react-i18next";
import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import RequirementTypesState from "infrastructure/store/requirementTypes/RequirementTypesState";
import AlertWithButton from "features/shared/alerts/components/AlertWithButton";

const requirementsDataFilterJson = loadDataFilterConfig(
  "requirementsDataFilter"
);
const portalConfig = loadPortalConfig();

const RequirementsSection = () => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // store
  const requirementTypes = useSelector<IAppState, RequirementTypesState>(
    (store) => store.requirementTypes
  ).requiremntTypes;

  // state
  const [externalFilterData, setExternalFilterData] = useState<
    IExternalFilterData<any>[]
  >([]);
  const [showTypesDialog, setShowTypesDialog] = useState(
    !portalConfig.useFullRequirements
  ); // if not use full requirements - show requirements type dialog

  // side effects
  useEffect(() => {
    if (portalConfig.useFullRequirements) {
      getExternalFilterData();
    }
  }, []);

  // helpers
  const getExternalFilterData = async () => {
    let externalFilterData: IExternalFilterData<any>[] = [];

    // RequirementType
    externalFilterData.push({
      name: "RequirementTypeCode",
      data: requirementTypes,
    });

    setExternalFilterData(externalFilterData);
  };

  // handlers
  const openRequirementTypesDialogHandler = async () => {
    setShowTypesDialog(true);
  };

  // sub-renders
  const renderOpenTypeDialogBtn = (): JSX.Element => {
    return (
      <RolesChecker enabledRoles="Contributor">
        <button
          className="btn btn-sm btn-secondary"
          onClick={openRequirementTypesDialogHandler}
        >
          {tLabels("requirementsSection.createRequest")}
        </button>
      </RolesChecker>
    );
  };

  const renderNoRoleAlert = (): JSX.Element => { 
    return (
      <AlertWithButton 
        alertInfo={tLabels("requirementsSection.noPermissionsToCreate")}
      />
    );
  }

  // render
  return (
    <>
      <RenderWrapper isVisible={() => portalConfig.useFullRequirements}>
        <DataGrid
          gridId={DataGridId.requirementGrid}
          url={Customer_Requirements}
          filterJson={requirementsDataFilterJson}
          filterExternalData={externalFilterData}
          renderItem={(item) => <RequirementSimplified requirement={item} />}
          renderHeader={() => <RequirementSimplifiedHeader />}
          renderGridHeaderBtns={renderOpenTypeDialogBtn}
          renderNoContent={() => (
            <AlertWithButton 
              alertInfo={tLabels("requirementsSection.requirementsNotFound")}
              renderButton={renderOpenTypeDialogBtn} 
            />
          )}
        />
      </RenderWrapper>
      <RenderWrapper isVisible={() => !portalConfig.useFullRequirements}>
        <RolesChecker
          enabledRoles="Contributor"
          unauthorizedRender={renderNoRoleAlert}
        >
          <AlertWithButton 
            alertInfo={tLabels("requirementsSection.selectRequirement")}
            renderButton={renderOpenTypeDialogBtn} 
          />
        </RolesChecker>
      </RenderWrapper>
      <RequirementTypesDialog
        show={showTypesDialog}
        setShow={setShowTypesDialog}
        requirementTypes={requirementTypes}
      />
    </>
  );
};

export default RequirementsSection;
